export default defineNuxtPlugin(() => {
  if (typeof window !== 'undefined') {
    // Disable zoom with keyboard shortcuts (Ctrl/Cmd + +/-, Ctrl/Cmd + 0)
    document.addEventListener('keydown', (e) => {
      if (
        (e.ctrlKey || e.metaKey) && 
        (e.key === '+' || e.key === '-' || e.key === '=' || e.key === '0')
      ) {
        e.preventDefault()
        return false
      }
    }, { passive: false })

    // Disable zoom with Ctrl/Cmd + mouse wheel
    document.addEventListener('wheel', (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault()
        return false
      }
    }, { passive: false })

    // Disable pinch zoom on touchpad and touch devices
    document.addEventListener('gesturestart', (e: Event) => {
      e.preventDefault()
      return false
    }, { passive: false })

    document.addEventListener('gesturechange', (e: Event) => {
      e.preventDefault()
      return false
    }, { passive: false })

    document.addEventListener('gestureend', (e: Event) => {
      e.preventDefault()
      return false
    }, { passive: false })

    // Disable double-tap zoom on touch devices
    let lastTouchEnd = 0
    document.addEventListener('touchend', (e) => {
      const now = Date.now()
      if (now - lastTouchEnd <= 300) {
        e.preventDefault()
      }
      lastTouchEnd = now
    }, { passive: false })

    // Disable pinch zoom with touch events
    document.addEventListener('touchstart', (e) => {
      if (e.touches.length > 1) {
        e.preventDefault()
      }
    }, { passive: false })

    document.addEventListener('touchmove', (e) => {
      if (e.touches.length > 1) {
        e.preventDefault()
      }
    }, { passive: false })

  }
})